import {
  FaTextHeight,
  FaCheckSquare,
  FaRegCalendarAlt,
  FaClock,
  FaHashtag,
  FaStar,
  FaSlidersH,
  FaUpload,
  FaMapMarkerAlt,
  FaToggleOn,
  FaList,
  FaSignature,
  FaImages,
} from "react-icons/fa";

export const INITIAL_TEMPLATE = {
  template_id: "",
  template_name: "",
  description: "",
  categories: [
    {
      category_id: "",
      category_name: "",
      questions: [],
    },
  ],
};

export const QUESTION_TYPES = [
  { label: "Text", value: "text", icon: <FaTextHeight /> },
  { label: "Yes/No", value: "yes_no", icon: <FaToggleOn /> },
  {
    label: "Multiple Choice",
    value: "multiple_choice",
    icon: <FaCheckSquare />,
  },
  { label: "Checkbox Group", value: "checkbox_group", icon: <FaCheckSquare /> },
  { label: "Dropdown", value: "dropdown", icon: <FaList /> },
  { label: "Date", value: "date", icon: <FaRegCalendarAlt /> },
  { label: "Time", value: "time", icon: <FaClock /> },
  { label: "Number", value: "number", icon: <FaHashtag /> },
  { label: "Rating", value: "rating", icon: <FaStar /> },
  { label: "Slider", value: "slider", icon: <FaSlidersH /> },
  {
    label: "Long Text (Paragraph)",
    value: "long_text",
    icon: <FaTextHeight />,
  },
  { label: "File Upload", value: "file_upload", icon: <FaUpload /> },
  { label: "Location", value: "location", icon: <FaMapMarkerAlt /> },
  { label: "Boolean Toggle", value: "boolean", icon: <FaToggleOn /> },
  { label: "Dropdown with Search", value: "dropdown_search", icon: <FaList /> },
  { label: "Matrix/Grid", value: "matrix", icon: <FaList /> },
  { label: "Signature", value: "signature", icon: <FaSignature /> },
  { label: "Image Selection", value: "image_selection", icon: <FaImages /> },
];

export const Questionnaires = [
  {
    template_id: "1",
    template_name: "General Health Check",
    categories: [
      {
        category_id: "101",
        category_name: "Personal Information",
        questions: [
          {
            question_id: "1001",
            text: "What is your full name?",
            type: "text",
            is_required: true,
          },
          {
            question_id: "1002",
            text: "What is your age?",
            type: "number",
            is_required: true,
          },
          {
            question_id: "1003",
            text: "What is your gender?",
            type: "dropdown",
            options: [
              { label: "Male" },
              { label: "Female" },
              { label: "Other" },
            ],
            is_required: true,
          },
        ],
      },
      {
        category_id: "102",
        category_name: "Medical History",
        questions: [
          {
            question_id: "2001",
            text: "Do you have any pre-existing conditions?",
            type: "checkbox_group",
            options: [
              { label: "Diabetes", dependent_questions: [] },
              {
                label: "Hypertension",
                dependent_questions: [
                  {
                    question_id: "3001",
                    text: "How long have you had hypertension?",
                    type: "text",
                    is_required: true,
                  },
                  {
                    question_id: "3002",
                    text: "Are you on medication for hypertension?",
                    type: "yes_no",
                    is_required: true,
                    dependent_questions: {
                      yes: [
                        {
                          question_id: "3003",
                          text: "What medication are you taking?",
                          type: "text",
                          is_required: true,
                        },
                      ],
                      no: [
                        {
                          question_id: "3004",
                          text: "Have you consulted a doctor for hypertension?",
                          type: "yes_no",
                          is_required: false,
                        },
                      ],
                    },
                  },
                ],
              },
              { label: "Heart Disease", dependent_questions: [] },
              { label: "None", dependent_questions: [] },
            ],
            is_required: true,
          },
          {
            question_id: "2002",
            text: "Are you currently taking any medications?",
            type: "text",
            is_required: false,
          },
        ],
      },
    ],
  },
];
